import React from 'react';
import {Alert, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';
import Icon from '../Icon';

class SurveyDeleteButton extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {modal: false};
        this.onDelete = this.onDelete.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    onDelete() {
        // Restore when https://github.com/reactstrap/reactstrap/issues/1819 is fixed
        // this.setState({modal: false}, () => this.props.onDelete());
        this.props.onDelete();
    }

    toggleModal() {
        this.setState({modal: !this.state.modal});
    }

    render() {
        const {children, disabled, item} = this.props;
        return (
            <a onClick={!disabled ? this.toggleModal : undefined} className={classNames({disabled, 'text-danger': !disabled})}>
                {children}
                <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        <FormattedMessage {...messages.surveys.modals.remove.title} values={{name: item.name}} />
                    </ModalHeader>
                    <ModalBody>
                        {(item.stats.completed > 0 || item.stats.started > 0) && (
                            <Alert color="warning">
                                <FormattedMessage {...messages.surveys.modals.remove.usedAlert} />
                            </Alert>
                        )}
                        <FormattedMessage {...messages.surveys.modals.remove.body} values={{name: item.name}} />
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-outline-secondary mr-auto" type="button" onClick={this.toggleModal}>
                            <FormattedMessage {...messages.buttons.cancel} />
                        </button>
                        <button className="btn btn-primary delete-button" type="button" onClick={this.onDelete}>
                            <Icon icon="trash" /><FormattedMessage {...messages.surveys.button.remove} />
                        </button>
                    </ModalFooter>
                </Modal>
            </a>
        );
    }
}

export default SurveyDeleteButton;
